<template>
  <div class="productTableCom">
    <v-data-table
      :headers="headersTmp"
      :items="masterItems"
      :item-key="itemKey"
      :hide-default-header="false"
      :items-per-page="-1"
      hide-default-footer
      :no-data-text="$t('common.common_not-register')"
      class="rounded-lg"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr
            v-for="(item, trIndex) in getFormatRow(items)"
            :key="`group-${trIndex}`"
            v-bind:class="{
              rowColor: item.customerIndex % 2 !== 0
            }"
          >
            <template v-for="(header, parentIndex) in headersTmp">
              <td
                v-bind:class="{
                  tdStyleCenter: getAlign(header.value) === 'center',
                  tdStyleEnd: getAlign(header.value) === 'end',
                  DisplayNone: getAlign(header.value) === ' d-none',
                  firstTd: item.isLastRow && 0 === parentIndex,
                  lastTd:
                    item.isLastRow && headersTmp.length - 1 === parentIndex
                }"
                :key="parentIndex"
                v-if="
                  (item.isFirst && !('rowspan' in header)) || header.rowspan
                "
                :rowspan="item.recipientLength"
                class="parentIndexTd"
              >
                <slot :name="header.value" v-bind:item="item.customerList">
                  {{ getDefaultValue(item.customerList, header) }}
                </slot>
              </td>
              <td
                v-if="'rowspan' in header && !header.rowspan"
                :key="parentIndex"
              >
                <span v-if="isName(header, 'recipient')">
                  <span v-if="item.recipientIndex > -1">
                    <InfoSummary
                      :displayData="item.recipientInfoSummary"
                      isMaster="true"
                    />
                  </span>
                  <span v-else>
                    {{ getDefaultValue(item.recipientInfo, header) }}
                  </span>
                </span>
                <span v-else>
                  <div class="text-center">
                    {{ getDefaultValue(item.recipientInfo, header) }}
                  </div>
                </span>
              </td>
            </template>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>
<script>
// import HelpCircle from '@/components/items/Buttons/HelpCircle'
import {
  commonUtil,
  currencyUtil,
  consumptionTaxUtil,
  countryUtil,
  countryCallingCodeUtil
} from '@/util'
import InfoSummary from '@/components/items/Designs/InfoSummary'

export default {
  name: 'ProductTable',

  components: {
    // HelpCircle
    InfoSummary
  },
  props: {
    headers: [],
    masterItems: {
      type: Array,
      require: true,
      default: () => []
    },
    itemKey: String,
    search: { default: '' }
  },
  data: () => ({
    itemsDetail: []
    // checkbox: [],
  }),
  created() {
    this.createHeaders()
  },
  computed: {
    headersTmp() {
      const headersTmp = this.headers.map((header) => {
        const tmp = { ...header }
        tmp.text = this.$t(tmp.text)
        delete tmp.inputType
        delete tmp.unit
        return tmp
      })
      return headersTmp
    },
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    createInfoSummary(recipient) {
      return {
        nameNormal: recipient.name,
        postalCode: recipient.postalCode,
        address:
          countryUtil.getRegionInfo(
            recipient.addressCountryId,
            recipient.regionId
          ).label +
          commonUtil.getSeparateWordsBySpace([
            recipient.address1,
            recipient.address2
          ]),
        phone: countryCallingCodeUtil.formatPhoneNumber(
          recipient.phoneNumber,
          recipient.phoneNumberCountryId,
          false
        )
      }
    },
    getFormatRow(customerList) {
      return customerList.reduce((result, current, currentIndex) => {
        let isMinRecipientId = true

        const isLastRow = customerList.length - 1 === currentIndex

        if (!current.recipients.length) {
          result.push({
            customerIndex: currentIndex,
            isLastRow: isLastRow,
            customerId: current.customerId,
            isFirst: isMinRecipientId,
            recipientIndex: -1,
            recipientLength: 1,
            recipientInfo: {},
            customerList: current
          })
        } else {
          current.recipients.map((ele, index) => {
            result.push({
              customerIndex: currentIndex,
              isLastRow: isLastRow,
              customerId: current.customerId,
              isFirst: isMinRecipientId,
              recipientIndex: index,
              recipientLength: current.recipients.length,
              recipientInfoSummary: this.createInfoSummary(ele),
              recipientInfo: ele,
              customerList: current
            })
            isMinRecipientId = false
          })
        }

        return result
      }, [])
    },

    createHeaders() {
      this.itemsDetail = this.headers.map((header) => {
        return {
          value: header.value,
          inputType: 'inputType' in header ? header.inputType : '',
          unit: 'unit' in header ? header.unit : '',
          currencyIdName:
            'currencyIdName' in header ? header.currencyIdName : '',
          align: 'align' in header ? header.align : ''
        }
      })
    },
    isName(header, name) {
      return header.value === name
    },
    getRowValue(obj, path) {
      let tmp = this.getValue(obj, path)
      return typeof tmp === 'undefined' ? '' : tmp
    },
    getValue(obj, path) {
      if (!path) return obj
      const properties = path.split('.')
      return this.getValue(obj[properties.shift()], properties.join('.'))
    },
    getItemsDetailRecord(value) {
      return this.itemsDetail.find((header) => header.value === value)
    },
    getUnit(item, header) {
      const tmp = this.getItemsDetailRecord(header.value)
      if (!tmp.currencyIdName) return ''

      const currencyId = item[tmp.currencyIdName]
      return currencyUtil.findCurrencyNameById(currencyId).unitName
    },
    getAlign(value) {
      const tmp = this.getItemsDetailRecord(value)
      return tmp ? tmp.align : ''
    },

    formatHyphen(str) {
      return commonUtil.nullEmptyFormatHyphen(str)
    },
    getDefaultValue(item, header) {
      const val = this.getRowValue(item, header.value)
      return val ? val + this.getUnit(item, header) : '-'
    }
  }
}
</script>
<style lang="scss" scoped>
.productTableCom {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1);
    border-collapse: collapse;
    text-align: center !important;
    padding: 10px 0px !important;
    white-space: pre-wrap;
    border: 1px solid #d8d8d8;
    border-right: 0;
  }
  ::v-deep .v-data-table th:last-child {
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table td {
    border-collapse: collapse;
    border-left: 1px solid #d8d8d8;
    border-bottom: 1px solid #d8d8d8;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td {
    border-collapse: collapse;
    border-left: 1px solid #d8d8d8;
    border-bottom: 1px solid #d8d8d8;
    border-spacing: 0;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table .parentIndexTd:last-child {
    border-right: 1px solid #d8d8d8 !important;
  }
  ::v-deep .v-data-table tr:hover td {
    background-color: #eee;
  }

  ::v-deep .v-data-table thead th:first-child {
    border-radius: 10px 0 0 0;
  }
  ::v-deep .v-data-table thead th:last-child {
    border-radius: 0 10px 0 0;
  }
  ::v-deep .v-data-table td:last-child {
    padding: 0 !important;
  }

  .rowColor {
    background-color: rgba(213, 213, 213, 0.1);
  }
  .firstTd {
    border-radius: 0 0 0 10px;
  }
  .lastTd {
    border-radius: 0 0 10px 0;
  }
}
</style>
